import { render, staticRenderFns } from "./CRUDTiposKits.vue?vue&type=template&id=0eec98a4&"
import script from "./CRUDTiposKits.vue?vue&type=script&lang=js&"
export * from "./CRUDTiposKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports